import axios from 'axios';
export const sendFeedBack = (info) => {
	return axios.post('https://api.imi.ai/v4/feedback', info).then((response) => {return response;});
}

export const sendSubscriber=(email)=>{
	return axios.post('https://api.imi.ai/v4/subscribe', email).then((response) => {return response;});
}